var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWozLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 38,
    viewBox: "0 0 163 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 23,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3444 0H44.1468V19.191H66.3444V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7598 19.1728H60.8102L66.3444 9.57732L60.8102 0H49.7598L44.2256 9.57732L49.7598 19.1728Z",
    fill: "#86C7ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_315_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 34,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3062 0H22.1128V37.9332H55.3062V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_315_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6042 15.6306L25.9801 16.2796L27.647 19.1728H27.6531L35.0967 32.0619L38.7155 38.3214H49.7658L55.3001 28.7441L51.5722 22.2965L42.4495 6.49002L38.7095 0H27.6349L22.1188 9.57732L25.5982 15.6306",
    fill: "#A066CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_315_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1752 0H0V37.9332H33.1752V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_315_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7582 16.0916H3.74608L13.2143 32.535L13.2386 32.5229L16.5906 38.3214H27.641L33.1752 28.7441L27.641 19.1668L22.1128 9.60158L22.131 9.57126L16.5846 0H5.53426L0 9.57732L3.7582 16.0977",
    fill: "#1836B2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7439 33.1356L73.3305 4.79785H79.7134L85.3022 28.5319H83.5928L89.4847 4.79785H95.5645L101.456 28.5319H99.747L105.336 4.79785H111.719L104.305 33.1356H97.4618L91.5335 10.3174H93.5096L87.5814 33.1356H80.7378H80.7439Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.358 33.1355C124.297 33.1355 122.381 32.7777 120.611 32.068C118.841 31.3583 117.301 30.3515 115.992 29.0656C114.677 27.7737 113.652 26.2694 112.919 24.5529C112.179 22.8364 111.816 20.9683 111.816 18.9545C111.816 16.9408 112.179 15.0727 112.901 13.3561C113.622 11.6396 114.646 10.1354 115.956 8.86165C117.271 7.58184 118.811 6.58711 120.575 5.87745C122.345 5.1678 124.266 4.80994 126.358 4.80994C128.449 4.80994 130.37 5.1678 132.14 5.87745C133.91 6.58711 135.45 7.58791 136.759 8.86165C138.075 10.1415 139.093 11.6396 139.814 13.3561C140.536 15.0787 140.899 16.9408 140.899 18.9545C140.899 20.9683 140.53 22.8364 139.796 24.5529C139.063 26.2755 138.032 27.7797 136.723 29.0656C135.408 30.3575 133.868 31.3583 132.104 32.068C130.334 32.7777 128.425 33.1355 126.358 33.1355ZM126.358 27.9799C127.612 27.9799 128.77 27.7615 129.837 27.3188C130.904 26.876 131.843 26.2573 132.656 25.4567C133.468 24.656 134.092 23.7038 134.535 22.5999C134.977 21.4959 135.195 20.2768 135.195 18.9545C135.195 17.6323 134.977 16.4192 134.535 15.3274C134.092 14.2356 133.468 13.2833 132.656 12.4706C131.843 11.6578 130.904 11.0391 129.837 10.6085C128.77 10.1778 127.606 9.96556 126.358 9.96556C125.109 9.96556 123.945 10.1778 122.878 10.6085C121.811 11.0391 120.872 11.6578 120.059 12.4706C119.247 13.2833 118.623 14.2356 118.18 15.3274C117.738 16.4192 117.52 17.6323 117.52 18.9545C117.52 20.2768 117.738 21.4959 118.18 22.5999C118.623 23.7038 119.247 24.656 120.059 25.4567C120.872 26.2573 121.811 26.876 122.878 27.3188C123.945 27.7615 125.109 27.9799 126.358 27.9799Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.281 33.1356V28.3803L155.168 9.93527H143.045V4.79785H162.618V9.55315L149.774 27.9981H163V33.1295H142.287L142.281 33.1356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWozLogoDark);
export default __webpack_public_path__ + "static/media/WOZLogoDark.9b35bd6ceaeea1ea6a7f9a2e169992c2.svg";
export { ForwardRef as ReactComponent };